export default "__VITE_ASSET__BxZy5KEv__"